export const fetch_shared_permissions = () => (dispatch) => {
    var url = global.config.server_path+'user/fetch_shared_permissions';
    return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({})})
    .then(resp => resp.json())
    .then(resp => validate_response(resp))
    .then(resp => Promise.resolve(resp.data))
    .catch(err => Promise.reject(err))
}

var validate_response = (response) => response.response_code === 1 ? Promise.resolve(response) : Promise.reject(response)